var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchoolCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.335,
    height: 169.766,
    viewBox: "0 0 241.335 169.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3005",
    "data-name": "Group 3005",
    transform: "translate(-732.965 -1944.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-30",
    transform: "translate(751.078 1944.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1004",
    "data-name": "Rectangle 1004",
    width: 77.001,
    height: 25.778,
    transform: "translate(60.415 12.171)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M246.726,81.238s-69.223-9.674-70.877-9.973,75.51-15.7,75.51-15.7L326.912,72.5Z",
    transform: "translate(-150.245 -55.56)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M342.535,95.2l-.183-.1c-.12-.062-.3-.163-.532-.283-.466-.245-1.165-.6-2.078-1.014a64.923,64.923,0,0,0-7.977-2.94,93.37,93.37,0,0,0-12.307-2.753,118,118,0,0,0-15.379-1.367,91.731,91.731,0,0,0-15.4.94,87.29,87.29,0,0,0-12.314,2.718,74.509,74.509,0,0,0-8,2.878l-1.223.54-.885.419-.54.264c-.12.062-.186.089-.186.089l.182-.132.532-.283.878-.435,1.216-.559a69.77,69.77,0,0,1,7.992-2.94,85.673,85.673,0,0,1,12.326-2.761,90.8,90.8,0,0,1,15.433-.955,116.926,116.926,0,0,1,15.406,1.383,91,91,0,0,1,12.315,2.8,61.243,61.243,0,0,1,7.969,3.006c.916.419,1.6.777,2.066,1.045.233.128.388.237.524.3Z",
    transform: "translate(-205.115 -74.488)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M476.879,82.541a10.8,10.8,0,0,0-1.359-4.555,3.336,3.336,0,0,0-4.61-.8l1.942.462c1.484.808,1.868,2.718,2.008,4.423a51.115,51.115,0,0,1-.311,11.083c.656.062,1.6-.128,2.252-.066A41.674,41.674,0,0,0,476.879,82.541Z",
    transform: "translate(-330.736 -68.425)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 2.338,
    cy: 2.338,
    r: 2.338,
    transform: "translate(142.772 21.573)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M481.156,128.34a23.912,23.912,0,0,0-.583-5.67,7.955,7.955,0,0,0-3.076-4.66l-2.237.078a3.766,3.766,0,0,0-2.532,2.882,18.494,18.494,0,0,0-.264,4.019,6.177,6.177,0,0,1-1.115,3.8c.742.2,1.421.579,2.147.827a2.839,2.839,0,0,0,2.241-.027,3.71,3.71,0,0,0,1.441-2.361,4.719,4.719,0,0,1,.221,2.672,8.07,8.07,0,0,1,1.868.2,1.717,1.717,0,0,0,1.689-.586A2.117,2.117,0,0,0,481.156,128.34Z",
    transform: "translate(-331.005 -93.758)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1005",
    "data-name": "Rectangle 1005",
    width: 114.492,
    height: 10.404,
    transform: "translate(43.875 37.685)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1006",
    "data-name": "Rectangle 1006",
    width: 31.949,
    height: 10.404,
    transform: "translate(126.419 37.685)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M337.432,157.1c0,.058-25.631.1-57.242.1s-57.25-.043-57.25-.1,25.631-.1,57.25-.1S337.432,157.047,337.432,157.1Z",
    transform: "translate(-179.065 -117.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M337.432,161.661c0,.058-25.631.1-57.242.1s-57.25-.043-57.25-.1,25.631-.1,57.25-.1S337.432,161.607,337.432,161.661Z",
    transform: "translate(-179.065 -120.395)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M337.432,166.231c0,.054-25.631.1-57.242.1s-57.25-.047-57.25-.1,25.631-.1,57.25-.1S337.432,166.173,337.432,166.231Z",
    transform: "translate(-179.065 -123.19)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M337.432,170.841c0,.054-25.631.1-57.242.1s-57.25-.047-57.25-.1,25.631-.1,57.25-.1S337.432,170.763,337.432,170.841Z",
    transform: "translate(-179.065 -126.01)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M337.432,175.251c0,.054-25.631.1-57.242.1s-57.25-.047-57.25-.1,25.631-.1,57.25-.1S337.432,175.193,337.432,175.251Z",
    transform: "translate(-179.065 -128.708)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1007",
    "data-name": "Rectangle 1007",
    width: 148.426,
    height: 18.536,
    transform: "translate(24.625 64.582)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M459.924,243.265a1.314,1.314,0,0,1,0-.214v-.594c0-.54-.019-1.278-.031-2.194,0-1.891-.039-4.516-.062-7.6l.124.124h-7.029c-.031.027.256-.256.136-.132h0v5.7c0,1.783,0,3.433-.019,4.9l-.109-.109,5.087.058,1.425.027a4.793,4.793,0,0,1,.516.023,3.456,3.456,0,0,1-.474.023l-1.4.027-5.157.054h-.1v-.109c0-1.464,0-3.107-.023-4.9v-5.685h0c-.116.117.167-.167.136-.14h7.153v.124c-.027,3.107-.047,5.771-.062,7.682,0,.9-.023,1.635-.035,2.167v.567A1.189,1.189,0,0,1,459.924,243.265Z",
    transform: "translate(-319.645 -163.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1008",
    "data-name": "Rectangle 1008",
    width: 22.893,
    height: 12.536,
    transform: "translate(150.154 67.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1009",
    "data-name": "Rectangle 1009",
    width: 25.907,
    height: 18.536,
    transform: "translate(147.141 64.582)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M488.346,240.526c-.074,0-.136-4.093-.136-9.138s.062-9.138.136-9.138.136,4.089.136,9.138S488.42,240.526,488.346,240.526Z",
    transform: "translate(-341.318 -157.516)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M519.4,236.786c0,.074-5.2.132-11.619.132s-11.619-.058-11.619-.132,5.2-.136,11.619-.136S519.4,236.7,519.4,236.786Z",
    transform: "translate(-346.18 -166.324)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M519.4,245.256c0,.074-5.2.132-11.619.132s-11.619-.058-11.619-.132,5.2-.136,11.619-.136S519.4,245.178,519.4,245.256Z",
    transform: "translate(-346.18 -171.505)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M519.4,253.872c0,.074-5.2.136-11.619.136s-11.619-.062-11.619-.136,5.2-.132,11.619-.132S519.4,253.8,519.4,253.872Z",
    transform: "translate(-346.18 -176.777)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1010",
    "data-name": "Rectangle 1010",
    width: 148.426,
    height: 9.146,
    transform: "translate(26.26 83.265)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 33.18,
    height: 6.924,
    transform: "translate(141.506 84.411)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1012",
    "data-name": "Rectangle 1012",
    width: 35.056,
    height: 9.146,
    transform: "translate(139.63 83.265)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M469.313,279.654a34.8,34.8,0,0,1-.124-4.4,36.474,36.474,0,0,1,.148-4.4,36.27,36.27,0,0,1,.12,4.4A36.874,36.874,0,0,1,469.313,279.654Z",
    transform: "translate(-329.683 -187.243)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1013",
    "data-name": "Rectangle 1013",
    width: 89.39,
    height: 2.186,
    transform: "translate(36.932 86.792)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M287.167,293.126c0,.074-24.6.132-54.932.132s-54.936-.058-54.936-.132,24.59-.136,54.936-.136S287.167,293.048,287.167,293.126Z",
    transform: "translate(-151.149 -200.785)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M297.407,293.236c0,.074-24.6.132-54.932.132s-54.936-.058-54.936-.132,24.59-.136,54.936-.136S297.407,293.162,297.407,293.236Z",
    transform: "translate(-157.412 -200.852)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M332.1,269.586c0,.074-32.365.132-72.275.132s-72.283-.058-72.283-.132,32.353-.136,72.283-.136S332.1,269.508,332.1,269.586Z",
    transform: "translate(-157.412 -186.386)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1014",
    "data-name": "Rectangle 1014",
    width: 148.426,
    height: 9.146,
    transform: "translate(14.749 141.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    width: 33.18,
    height: 6.924,
    transform: "translate(129.991 142.453)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    width: 35.056,
    height: 9.146,
    transform: "translate(128.116 141.308)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M439.669,429.134a36.24,36.24,0,0,1-.12-4.4,35.573,35.573,0,0,1,.148-4.4,72.389,72.389,0,0,1-.027,8.8Z",
    transform: "translate(-311.554 -278.673)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 89.39,
    height: 2.186,
    transform: "translate(25.421 144.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M257.527,442.582c0,.078-24.6.136-54.932.136s-54.936-.058-54.936-.136,24.59-.132,54.936-.132S257.527,442.508,257.527,442.582Z",
    transform: "translate(-133.019 -292.202)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M267.761,442.692c0,.078-24.6.136-54.932.136s-54.939-.058-54.939-.136,24.594-.132,54.939-.132S267.761,442.618,267.761,442.692Z",
    transform: "translate(-139.277 -292.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M302.448,419.042c0,.078-32.361.136-72.275.136s-72.283-.058-72.283-.136,32.357-.132,72.283-.132S302.448,418.968,302.448,419.042Z",
    transform: "translate(-139.277 -277.804)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 210.189,
    height: 9.146,
    transform: "translate(0 150.492)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 44.901,
    height: 6.924,
    transform: "translate(165.288 151.638)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 47.44,
    height: 9.146,
    transform: "translate(162.748 150.492)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M528.741,452.764a26.553,26.553,0,0,1-.163-4.4,27.176,27.176,0,0,1,.2-4.4,26.587,26.587,0,0,1,.163,4.4A25.121,25.121,0,0,1,528.741,452.764Z",
    transform: "translate(-366.008 -293.126)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 120.966,
    height: 2.186,
    transform: "translate(23.778 154.015)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M296.149,466.342c0,.078-33.285.136-74.334.136s-74.345-.058-74.345-.136,33.277-.132,74.345-.132S296.149,466.268,296.149,466.342Z",
    transform: "translate(-132.903 -306.735)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M343.092,442.692c0,.078-43.794.136-97.805.136s-97.817-.058-97.817-.136,43.786-.132,97.817-.132S343.092,442.618,343.092,442.692Z",
    transform: "translate(-132.903 -292.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 49.017,
    height: 17.977,
    transform: "translate(169.591 112.986) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 156.244,
    height: 3.767,
    transform: "translate(169.595 95.685) rotate(180)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1024",
    "data-name": "Rectangle 1024",
    width: 156.244,
    height: 3.767,
    transform: "translate(169.595 115.945) rotate(180)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M253.125,294.56l-.245,22.415H144.33V294.56Z",
    transform: "translate(-130.982 -201.745)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 5.165,
    cy: 5.577,
    rx: 5.165,
    ry: 5.577,
    transform: "translate(89.992 99.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M339.62,315.957a5.98,5.98,0,1,1,5.973,6.369A6.19,6.19,0,0,1,339.62,315.957Zm1.6,0a4.381,4.381,0,1,0,4.365-4.777A4.58,4.58,0,0,0,341.224,315.957Z",
    transform: "translate(-250.432 -210.932)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1025",
    "data-name": "Rectangle 1025",
    width: 43.06,
    height: 11.996,
    transform: "translate(73.145 110.578) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M280.346,322.107c.233,0,.419-2.14.419-4.781s-.186-4.777-.419-4.777-.416,2.14-.416,4.777S280.128,322.107,280.346,322.107Z",
    transform: "translate(-213.923 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M265.716,322.107c.233,0,.419-2.14.419-4.781s-.186-4.777-.419-4.777-.416,2.14-.416,4.777S265.486,322.107,265.716,322.107Z",
    transform: "translate(-204.974 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M251.056,322.107c.229,0,.419-2.14.419-4.781s-.19-4.777-.419-4.777-.415,2.14-.415,4.777S250.826,322.107,251.056,322.107Z",
    transform: "translate(-196.007 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M236.389,322.107c.229,0,.416-2.14.416-4.781s-.186-4.777-.416-4.777-.419,2.14-.419,4.777S236.16,322.107,236.389,322.107Z",
    transform: "translate(-187.034 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M221.729,322.107c.229,0,.416-2.14.416-4.781s-.186-4.777-.416-4.777-.419,2.14-.419,4.777S221.5,322.107,221.729,322.107Z",
    transform: "translate(-178.068 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M207.069,322.107c.229,0,.416-2.14.416-4.781s-.186-4.777-.416-4.777-.419,2.14-.419,4.777S206.836,322.107,207.069,322.107Z",
    transform: "translate(-169.101 -212.749)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M423.641,318.816c-.058,0-.1-3.775-.1-8.431s.043-8.435.1-8.435.1,3.775.1,8.435S423.7,318.816,423.641,318.816Z",
    transform: "translate(-301.762 -206.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M470.965,309.1c0,.058-10.419.1-23.278.1s-23.278-.043-23.278-.1,10.419-.1,23.278-.1S470.965,309.047,470.965,309.1Z",
    transform: "translate(-302.294 -210.577)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M470.965,316.121c0,.054-10.419.1-23.278.1s-23.278-.047-23.278-.1,10.419-.1,23.278-.1S470.965,316.063,470.965,316.121Z",
    transform: "translate(-302.294 -214.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M470.965,323.131c0,.054-10.419.1-23.278.1s-23.278-.047-23.278-.1,10.419-.1,23.278-.1S470.965,323.077,470.965,323.131Z",
    transform: "translate(-302.294 -219.159)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M470.965,330.141c0,.058-10.419.1-23.278.1s-23.278-.043-23.278-.1,10.419-.1,23.278-.1S470.965,330.087,470.965,330.141Z",
    transform: "translate(-302.294 -223.447)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M470.965,337.151c0,.058-10.419.1-23.278.1s-23.278-.043-23.278-.1,10.419-.1,23.278-.1S470.965,337.1,470.965,337.151Z",
    transform: "translate(-302.294 -227.734)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1026",
    "data-name": "Rectangle 1026",
    width: 50.582,
    height: 24.089,
    transform: "translate(119.009 91.856)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    width: 126.496,
    height: 16.571,
    transform: "translate(39.708 48.07)",
    fill: "#8ad7ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 27.942,
    height: 11.767,
    transform: "translate(138.259 50.407)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1029",
    "data-name": "Rectangle 1029",
    width: 31.013,
    height: 16.571,
    transform: "translate(135.191 48.07)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M310.426,201.585v-1.79c0-1.165,0-2.9-.027-5.142l.047.039-79.774.058h0l.109-.1v6.932l-.109-.1,56.644.043,16.94.027h.074l-16.913.027-56.722.043h-.1V194.56h.109l79.774.054h.043v.039c0,2.252,0,3.988-.027,5.165v1.32A1.259,1.259,0,0,1,310.426,201.585Z",
    transform: "translate(-183.744 -140.58)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M458.189,195.606c-.062,0-.109-3.716-.109-8.3s.047-8.291.109-8.291.1,3.713.1,8.291S458.247,195.606,458.189,195.606Z",
    transform: "translate(-322.889 -131.075)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1030",
    "data-name": "Rectangle 1030",
    width: 183.482,
    height: 25.6,
    transform: "translate(8.676 115.564)",
    fill: "#db81d2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1031",
    "data-name": "Rectangle 1031",
    width: 180.488,
    height: 19.103,
    transform: "translate(8.676 118.764)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M312.492,371.965h-1.837l-5.266.027-19.359.043-63.875.039-63.887-.039-19.359-.043-5.266-.027h0l5.266-.023,19.359-.043,63.887-.039,63.875.039,19.359.043,5.266.023h1.837Z",
    transform: "translate(-123.325 -249.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M312.492,385.109h-1.837l-5.266.027-19.359.043-63.875.039-63.887-.039-19.359-.043-5.266-.027h0l5.266-.027,19.359-.043L222.155,385l63.875.039,19.359.043,5.266.027h1.837Z",
    transform: "translate(-123.325 -257.063)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M312.492,398.269h-1.837l-5.266.023-19.359.043-63.875.039-63.887-.039-19.359-.043-5.266-.023h0l5.266-.027,19.359-.043,63.887-.039,63.875.039,19.359.043,5.266.027h1.371C312.333,398.257,312.492,398.269,312.492,398.269Z",
    transform: "translate(-123.325 -265.112)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1032",
    "data-name": "Rectangle 1032",
    width: 50.617,
    height: 25.6,
    transform: "translate(141.541 115.564)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M552.213,238.33a1.1,1.1,0,0,1,.536.474,1.686,1.686,0,0,1-.023,1.81l-.043-.14a1.281,1.281,0,0,1,.718,1.278,1.677,1.677,0,0,1-.827,1.34,2.349,2.349,0,0,1-1.243.338,4.662,4.662,0,0,1-.858-.07c-.2-.031-.307-.058-.3-.074s.451.031,1.165,0a2.33,2.33,0,0,0,1.165-.357,1.515,1.515,0,0,0,.726-1.188,1.118,1.118,0,0,0-.583-1.1l-.113-.043.066-.1a1.619,1.619,0,0,0,.082-1.647A2.49,2.49,0,0,0,552.213,238.33Z",
    transform: "translate(-379.216 -167.352)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-30",
    transform: "translate(868.984 2003.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M583.169,367.376c.226.032,7.863,5.366,7.863,5.366s1.865-3.541,2.71-3.645a9.013,9.013,0,0,1,3.636,1.134,1.933,1.933,0,0,0,1.237.357c.506.045,1.4,1.287,1.4,1.287l1.721,1.26s-.537.985-.682,1.156-1.305-.307-1.287-.488.145,1.111-.745,1.147a5.01,5.01,0,0,1-2.05-.533l-.3-1.49-1.974-.605-.5.619s2.258.452,2.172,1.179a1.125,1.125,0,0,1-.727.935l-1.856-.041-4.065.962s-10.7-2.326-11.088-3.518S580.034,366.96,583.169,367.376Z",
    transform: "translate(-540.745 -308.38)",
    fill: "#fff",
    stroke: "#24282b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M558.513,246.233a2.48,2.48,0,0,0,.605-1.617c-.059-.8-.452-1.129-1.08-1.63h0c.3-.673.741-1.7.375-2.344a2.5,2.5,0,0,0-2.069-1.233c.221-1.328-1.414-2.5-2.782-2.561-1.052-.045-2.078-.357-3.162,1.075,0,0-.316-1.129-2.321-.858a2.658,2.658,0,0,0-2.172,2.019,2.253,2.253,0,0,0-2.886-.75,2.076,2.076,0,0,0-1.545,2.394,2.524,2.524,0,0,0-2.208,1.188,2.438,2.438,0,0,0,0,2.48,1.734,1.734,0,0,0,.059,3.284l16.639,1.1h0l.8.569a1.685,1.685,0,0,0,2.1-1.093A1.954,1.954,0,0,0,558.513,246.233Z",
    transform: "translate(-518.565 -236.788)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.9,27.567l-.521-1.148.307-9.132A2.37,2.37,0,0,1,0,14.579c.091-1.806,1.13-2.26,2.033-2.26a1.312,1.312,0,0,1,.8.265L2.959,9C2.919,4.067,5.813-.1,10.846,0l.45.036a8.908,8.908,0,0,1,8.3,8.8c.009,4.292-.037,9.028-.233,11.309-.435,4.73-5.307,5.1-5.307,5.1l-.492,4.425L10.429,39Z",
    transform: "translate(18.913 4.036)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M560.335,298.818a11.824,11.824,0,0,1-6.115-2.308s1.2,3.527,5.993,3.482Z",
    transform: "translate(-527.392 -269.536)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M574.327,274.3a.682.682,0,0,1-.718.628.651.651,0,0,1-.659-.664.687.687,0,0,1,.718-.628.65.65,0,0,1,.659.664Z",
    transform: "translate(-537.663 -256.995)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M574.146,269.785c-.095.086-.583-.334-1.323-.388s-1.314.266-1.387.172.063-.2.312-.348a1.955,1.955,0,0,1,1.12-.248,1.834,1.834,0,0,1,1.043.425C574.124,269.587,574.192,269.749,574.146,269.785Z",
    transform: "translate(-536.822 -254.433)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M560.447,273.563a.682.682,0,0,1-.718.628.651.651,0,0,1-.659-.664.687.687,0,0,1,.718-.628.65.65,0,0,1,.659.664Z",
    transform: "translate(-530.052 -256.589)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M558.492,268.355c-.09.081-.583-.334-1.323-.393s-1.31.271-1.382.172.063-.194.312-.343a1.906,1.906,0,0,1,1.116-.248,1.862,1.862,0,0,1,1.048.425C558.474,268.156,558.537,268.318,558.492,268.355Z",
    transform: "translate(-528.241 -253.648)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M566.25,274.314a5.138,5.138,0,0,1,1.215-.117c.194,0,.375-.027.416-.154a.953.953,0,0,0-.081-.56c-.14-.452-.289-.948-.452-1.459a23.938,23.938,0,0,1-.958-3.794,24.076,24.076,0,0,1,1.265,3.713l.425,1.463a1.071,1.071,0,0,1,.041.736.452.452,0,0,1-.334.248,1.383,1.383,0,0,1-.325,0A4.6,4.6,0,0,1,566.25,274.314Z",
    transform: "translate(-533.989 -254.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M558.545,263.749c-.1.185-.727-.036-1.5-.081s-1.432.063-1.495-.131c-.027-.095.113-.257.4-.4a2.381,2.381,0,0,1,1.174-.208,2.258,2.258,0,0,1,1.111.375C558.482,263.482,558.59,263.663,558.545,263.749Z",
    transform: "translate(-528.118 -251.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M574.369,265.44c-.131.167-.641,0-1.26,0s-1.134.113-1.256-.059c-.05-.081.032-.248.258-.407a1.843,1.843,0,0,1,2.023.054C574.351,265.187,574.423,265.359,574.369,265.44Z",
    transform: "translate(-537.054 -252.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M540.582,277.936a.948.948,0,0,1-.158.072.565.565,0,0,1-.452,0,1.4,1.4,0,0,1-.6-1.283,1.837,1.837,0,0,1,.2-.8.668.668,0,0,1,.452-.415.294.294,0,0,1,.334.172c.041.095,0,.158.032.163s.077-.05.054-.185a.339.339,0,0,0-.122-.208.42.42,0,0,0-.312-.1.8.8,0,0,0-.623.474,1.93,1.93,0,0,0-.244.9,1.464,1.464,0,0,0,.772,1.436.624.624,0,0,0,.533-.059C540.573,278.013,540.6,277.94,540.582,277.936Z",
    transform: "translate(-519.12 -257.931)",
    fill: "#6f4439"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M562.588,285.621a1.071,1.071,0,0,1-.854.325.935.935,0,0,1-.474-.126,1.052,1.052,0,0,1-.425-.366,1.938,1.938,0,0,1-.212-1.215,2.118,2.118,0,0,1,.063-.321.452.452,0,0,1,.226-.307.411.411,0,0,1,.379.054l.239.154.822.528a3.583,3.583,0,0,1,.727.533,4.066,4.066,0,0,1-.808-.406l-.845-.488c-.154-.086-.352-.239-.425-.185a.854.854,0,0,0-.163.452,1.776,1.776,0,0,0,.167,1.084.876.876,0,0,0,.339.316.844.844,0,0,0,.393.131A1.92,1.92,0,0,0,562.588,285.621Z",
    transform: "translate(-530.891 -262.45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M557.677,268.346c-.027,0-.027-.271-.172-.723a3,3,0,0,0-1.188-1.567,3.044,3.044,0,0,0-2.814-.294,2.968,2.968,0,0,0-1.355,1.061,2.85,2.85,0,0,0,.131,3.446,2.935,2.935,0,0,0,1.409.962,3.017,3.017,0,0,0,3.853-2.15c.108-.452.086-.736.113-.736a.677.677,0,0,1,0,.194,2.588,2.588,0,0,1-.045.565,3.013,3.013,0,0,1-1.057,1.757,3.184,3.184,0,0,1-4.476-.452,3.1,3.1,0,0,1,1.3-4.855,3.2,3.2,0,0,1,2.99.357,3.017,3.017,0,0,1,1.183,1.676,2.221,2.221,0,0,1,.086.556A.587.587,0,0,1,557.677,268.346Z",
    transform: "translate(-525.836 -252.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M574.827,269.823a2.357,2.357,0,0,0-.167-.727,3.035,3.035,0,0,0-4.006-1.856,2.967,2.967,0,0,0-1.332,1.061,2.868,2.868,0,0,0,.131,3.446,2.968,2.968,0,0,0,1.409.962,3.021,3.021,0,0,0,3.852-2.15c.108-.452.09-.736.113-.736a.523.523,0,0,1,.023.194,2.261,2.261,0,0,1-.045.56,2.977,2.977,0,0,1-1.061,1.743,3.184,3.184,0,0,1-4.476-.452,3.1,3.1,0,0,1,1.314-4.828,3.162,3.162,0,0,1,2.985.357,3,3,0,0,1,1.183,1.676,2.5,2.5,0,0,1,.09.556A.5.5,0,0,1,574.827,269.823Z",
    transform: "translate(-535.272 -253.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M566.934,272.3c-.05.036-.3-.352-.79-.452s-.867.154-.9.1.05-.126.217-.221a1.093,1.093,0,0,1,.736-.108,1.08,1.08,0,0,1,.632.393A.518.518,0,0,1,566.934,272.3Z",
    transform: "translate(-533.431 -255.872)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M546.392,271.62a10.938,10.938,0,0,1-2.163.528,10.779,10.779,0,0,1-2.209.3A20.777,20.777,0,0,1,546.392,271.62Z",
    transform: "translate(-520.702 -255.888)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M555.188,244.932a.591.591,0,0,0,.194-.276.98.98,0,0,0-.1-.7,2.172,2.172,0,0,0-2.6-1.129,3.212,3.212,0,0,0-2.435-2.561,3.13,3.13,0,0,0-3.162,1.49,3.008,3.008,0,0,0-2.71-1,3.288,3.288,0,0,0-2.362,1.856,2.258,2.258,0,0,0-2.435.687,2.71,2.71,0,0,0-.406,2.678,1.6,1.6,0,0,0-1.021,1.472c-.077.781.257,1.906.971,1.752a1.966,1.966,0,0,0,.452,1.888c0,1,.068,1.626.086,2.534.036,1.87.939,1.73.939,1.73.122,3.762,1.585,3.162,2.71-3.9a.962.962,0,0,0,.411-.569c.063-.257.027-.569.2-.763a.452.452,0,0,1,.276-.135,2.394,2.394,0,0,0,1.807.036,2.339,2.339,0,0,0,1.328-1.409.931.931,0,0,0,1.165.1c.045-.027.086-.063.131-.095a2.62,2.62,0,0,0,1.445-1.355,1.221,1.221,0,0,1,.235-.108,1.513,1.513,0,0,0,1.73.108,2.321,2.321,0,0,0,.994-1.712,2.8,2.8,0,0,0,0-.339,1.888,1.888,0,0,1,1.31.262c1.4.8,2.434,3.866,2.434,3.866A5.312,5.312,0,0,0,555.188,244.932Z",
    transform: "translate(-518.573 -238.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M571.892,381.6s20.934-2.331,24.353-2.9c6.544-1.089,13.1-.045,15.867,5.483,1.269,2.516-.334,7.371-4.173,10.975-2.859,2.71-17.068,16.82-17.068,16.82l-12.195-10,15.076-11.517-29.222,4.033Z",
    transform: "translate(-533.046 -314.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M604.521,428.676l-7.832,8.13s5.921,10.682,4.62,12.326L584.44,434.52l11.671-13.17Z",
    transform: "translate(-543.963 -337.992)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M599.889,443.894a.9.9,0,0,0-1.156.343.863.863,0,0,0,.361,1.138.962.962,0,0,0,1.224-.375.9.9,0,0,0-.51-1.143",
    transform: "translate(-551.752 -350.306)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M584.44,448.9l1.179-1.328,15.83,14.593a1.807,1.807,0,0,1-.126,1.355Z",
    transform: "translate(-543.963 -352.37)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M609.47,455.02c-.077.077-.519-.244-1.156-.339s-1.152.054-1.2-.045.488-.452,1.256-.321S609.551,454.961,609.47,455.02Z",
    transform: "translate(-556.397 -356.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M612.2,460.4c-.05.095-.528-.081-1.107,0s-.985.384-1.061.307.271-.569,1-.673S612.268,460.328,612.2,460.4Z",
    transform: "translate(-557.988 -359.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M612.978,466.2c-.09-.045.154-.542.754-.795s1.143-.095,1.12,0-.452.122-.967.339S613.073,466.262,612.978,466.2Z",
    transform: "translate(-559.602 -362.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M613.578,449.585c-.1.041-.379-.393-.872-.768s-.985-.546-.967-.65.623-.086,1.2.361S613.663,449.558,613.578,449.585Z",
    transform: "translate(-558.932 -352.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M616.438,432.379a.95.95,0,0,1-.149.181l-.452.488-1.743,1.775-5.971,5.944-.072.072-.077-.068-1.517-1.242-7.52-6.215-2.258-1.9-.605-.524a1.223,1.223,0,0,1-.2-.2,1.353,1.353,0,0,1,.23.163l.637.492,2.308,1.852,7.556,6.161,1.518,1.247h-.149l6.025-5.881,1.807-1.734.488-.452A1.489,1.489,0,0,1,616.438,432.379Z",
    transform: "translate(-550.231 -343.113)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M674,433l10.28,8.916,10.2,4.747a1.355,1.355,0,0,1,.628,1.924h0a1.4,1.4,0,0,1-1.075.7c-2.882.3-13.491,1.355-14.2.664-.827-.8-11.477-8.694-11.477-8.694Z",
    transform: "translate(-589.975 -344.38)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M708.179,467.49l-15.989.781.709.583a1.427,1.427,0,0,0,1.107.276c1.355,0,5.054-.1,13.075-.9a1.423,1.423,0,0,0,1.1-.732Z",
    transform: "translate(-603.048 -363.293)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2937",
    "data-name": "Group 2937",
    transform: "translate(88.547 101.107)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    d: "M691.463,460.671a.853.853,0,0,1,1,.528.8.8,0,0,1-.524.98.9.9,0,0,1-1.052-.565.831.831,0,0,1,.659-.958",
    transform: "translate(-690.873 -460.647)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    d: "M712.511,460.693a4.149,4.149,0,0,1-.045-1.581,4.823,4.823,0,0,1,.786-1.378c-.054-.068-.208.032-.452.244a2.15,2.15,0,0,0-.623,1.061,2.109,2.109,0,0,0,.05,1.229C712.331,460.553,712.471,460.711,712.511,460.693Z",
    transform: "translate(-613.97 -357.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M5.726,33.576h0c-.322.37-.519.594-.519.594L0,23.527S3.412,13.553,3.441,13.3,5.134,0,5.134,0s5.295,2.063,5.923,6.464c.522,3.67-.638,13.441-.618,14.1A2.249,2.249,0,0,0,11,22.149a3.627,3.627,0,0,1,.981,2.159,7.4,7.4,0,0,1,1.344,2.149c.453,1.066,5.57,4.73,5.57,4.73L14.76,34.479s-1.118.046-2.569.046C9.613,34.525,5.984,34.38,5.726,33.576Z",
    transform: "translate(31.295 32.94)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    d: "M717.323,462.332a10.752,10.752,0,0,1,.33-1.287c.3-.659.781-1.048.732-1.116s-.677.235-1.007,1A1.53,1.53,0,0,0,717.323,462.332Z",
    transform: "translate(-616.758 -359.141)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    d: "M706.241,459.323a13.979,13.979,0,0,1,.375-2.019,16.829,16.829,0,0,1,.948-1.829,2.94,2.94,0,0,0-1.233,1.734A3.084,3.084,0,0,0,706.241,459.323Z",
    transform: "translate(-610.68 -356.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M698.97,455.2c.086,0,.33-.745.939-1.508s1.292-1.2,1.247-1.278a2.646,2.646,0,0,0-1.486,1.1A2.585,2.585,0,0,0,698.97,455.2Z",
    transform: "translate(-606.752 -355.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M693.854,451.805a6.466,6.466,0,0,1,.94-1.6,7.868,7.868,0,0,1,1.518-1.075c-.027-.081-.235-.032-.578.09a3,3,0,0,0-1.843,2.005C693.8,451.575,693.818,451.8,693.854,451.805Z",
    transform: "translate(-603.944 -353.204)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M506.89,394.581c.208.515-.718,17.059,15.248,17.163,14.331.09,33.612-12.822,35.807-12,1.441.542,26.2,21.679,26.2,21.679l8.925-10.307s-22.894-21.485-25.153-23.034c-4.819-3.311-8.211-3.288-16.142-1.874-7.1,1.26-24.48,6.937-24.48,6.937l-1.671-1.4Z",
    transform: "translate(-501.439 -318.228)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M594.833,387.758l.271-.108c.176-.068.452-.172.795-.3.709-.248,1.757-.605,3.13-.985a39.473,39.473,0,0,1,5.095-1.052,20.994,20.994,0,0,1,3.247-.226,17.04,17.04,0,0,1,3.613.452,17.615,17.615,0,0,1,7.4,3.762c2.213,2.028,4.517,4.236,6.969,6.54l15.975,15.072.072.072-.068.077-1.233,1.423c-1.319,1.531-2.71,3.085-4.065,4.517s-2.588,2.877-3.835,4.3l.036.077-14-11.919-6.007-5.113-2.71-2.3-1.265-1.079c-.208-.176-.411-.357-.619-.51a3.277,3.277,0,0,0-.673-.375,3.518,3.518,0,0,0-2.823.045l-2.362,1.143L598,403.079l-2.367,1.129-.614.289-.212.095.2-.113.605-.3,2.353-1.165,3.753-1.847,2.358-1.156a3.636,3.636,0,0,1,2.936-.063,3.963,3.963,0,0,1,.7.393c.221.158.42.339.628.51l1.274,1.075,2.71,2.29,6.052,5.1,14.042,11.9.036.072c1.238-1.445,2.52-2.927,3.753-4.458s2.448-2.99,3.767-4.516l1.215-1.4v.149l-15.957-15.085c-2.448-2.3-4.756-4.517-6.946-6.549a17.465,17.465,0,0,0-7.321-3.744,16.776,16.776,0,0,0-3.613-.452,21.011,21.011,0,0,0-3.229.2,40.4,40.4,0,0,0-5.086,1.016c-1.355.366-2.425.709-3.135.944l-.808.276Z",
    transform: "translate(-549.65 -318.108)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M538.391,341.552s-1.247-5.171-1-6.12c.718-2.71,3.758-16.332,3.446-20.451s-3.392-8.581-3.392-8.581l-3.586-1.242c-1.45,3.107-6.978,2.118-11.567-1.518l-6.386,1.436L509.733,333.4l-2.809,11.4c-1.49,5.79-.452,5.04-.452,5.04s6.942,2.15,12.434,1.188a37.684,37.684,0,0,0,11.436-4.6c3.211-2.475,8.3-2.3,8.3-2.3Z",
    transform: "translate(-501.017 -273.446)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M0,10.992,2.27,4.785,6.027,6.3l.108-.063.02-.069L8.514,2.276c-.008.012-.144.218-.09-.375.054-.61,1.147-.713,1.147-.713.075-.317.713-.616.713-.616L13.25.034a2.081,2.081,0,0,1,1.713.453l1.806,1.522s1.063,1.166,1.057,1.507a.6.6,0,0,1-.549.574s.136.936-.1,1.033a2.071,2.071,0,0,1-.751.052.682.682,0,0,1-.688.558c-.405,0-.6-.758-.6-.758l-1.272.17-1.022.619c-.8.98-2.465,3.013-3.179,3.718A8.037,8.037,0,0,1,7.4,11.2l-.089.116a9.558,9.558,0,0,1-2.673.453A30.932,30.932,0,0,1,0,10.992Z",
    transform: "translate(25.034 63.572)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M505.837,336.864h0l3.473-15.239.948-14.805s-7.9,1.034-10.063,8.175c-1.093,3.613-4.733,18.649-5.208,21.426s0,6.165,2.258,7.918,23.762,6.21,23.762,6.21l2.8-7.064Z",
    transform: "translate(-494.821 -275.19)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M571.28,386.315c0,.027.384-.122,1-.28a9.2,9.2,0,0,1,2.484-.253,8.385,8.385,0,0,1,1.355.14c.407.09.817.135,1,.352a.343.343,0,0,1,.072.343.488.488,0,0,1-.158.244c-.131.108-.244.095-.239.113s.113.05.285-.05a.583.583,0,0,0,.217-.271.451.451,0,0,0-.072-.452.953.953,0,0,0-.479-.285c-.185-.054-.379-.108-.592-.149a7.731,7.731,0,0,0-1.4-.163,7.925,7.925,0,0,0-2.511.334,3.573,3.573,0,0,0-.971.375Z",
    transform: "translate(-536.747 -318.39)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M572.08,389.732c0,.05,1.17-.348,2.629-.7s2.66-.524,2.656-.578a2.944,2.944,0,0,0-.8.045,17.169,17.169,0,0,0-1.9.348,17.845,17.845,0,0,0-1.852.555A2.8,2.8,0,0,0,572.08,389.732Z",
    transform: "translate(-537.186 -319.951)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M578.716,384.948a1.194,1.194,0,0,0-.059-.312,6.149,6.149,0,0,0-.253-.827,3.89,3.89,0,0,0-.257-.546,1.856,1.856,0,0,0-.452-.528,4,4,0,0,0-1.409-.754,5.81,5.81,0,0,0-1.581-.271,5.387,5.387,0,0,0-1.292.19c-.361.095-.641.185-.836.253a1.075,1.075,0,0,0-.3.122,8.587,8.587,0,0,0,1.161-.248,5.758,5.758,0,0,1,1.265-.14,5.872,5.872,0,0,1,1.527.271,4.159,4.159,0,0,1,1.355.714,2.231,2.231,0,0,1,.714.989A11.6,11.6,0,0,0,578.716,384.948Z",
    transform: "translate(-537.295 -316.255)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M573.85,379.691c0,.027.452-.09,1.152-.221a3.047,3.047,0,0,1,2.638.343,10.226,10.226,0,0,1,2.132,1.775,5.613,5.613,0,0,1,.6.971.948.948,0,0,0-.072-.3,3.011,3.011,0,0,0-.415-.75,8.859,8.859,0,0,0-2.136-1.847,3.3,3.3,0,0,0-.727-.384,2.117,2.117,0,0,0-.772-.108,6.051,6.051,0,0,0-1.269.176A4.647,4.647,0,0,0,573.85,379.691Z",
    transform: "translate(-538.156 -314.86)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M569.163,385.248a1.348,1.348,0,0,0,.131-.181l.361-.524a21.078,21.078,0,0,1,1.486-1.838H571.1l1.865-.235-.081-.059a2.032,2.032,0,0,0,.163.415.827.827,0,0,0,.334.361.451.451,0,0,0,.266.036.615.615,0,0,0,.253-.063.759.759,0,0,0,.37-.37.688.688,0,0,0,.041-.126v-.059h0l-.09.068h.321a2.586,2.586,0,0,0,.262,0l.14-.027a.317.317,0,0,0,.154-.081.541.541,0,0,0,.1-.28,1.359,1.359,0,0,0,0-.266,3.451,3.451,0,0,0-.041-.528l-.081.1a.691.691,0,0,0,.592-.42.546.546,0,0,0,0-.388,1.746,1.746,0,0,0-.167-.316,9.643,9.643,0,0,0-.9-1.107h0l-.958-.808q-.3-.262-.61-.515a3.67,3.67,0,0,0-.641-.483,2.033,2.033,0,0,0-.772-.226,2.736,2.736,0,0,0-.777.072l-2.746.528h0a2.481,2.481,0,0,0-.452.266.841.841,0,0,0-.325.406l.09-.063a1.061,1.061,0,0,0-.9.33,1.166,1.166,0,0,0-.23.849v-.045c-.682,1.111-1.233,2.019-1.63,2.669l-.452.732a1.182,1.182,0,0,0-.14.262,2.008,2.008,0,0,0,.172-.244l.452-.709c.406-.641.98-1.536,1.685-2.633h0v-.027a1.029,1.029,0,0,1,.208-.741.9.9,0,0,1,.763-.266h.072v-.068a.722.722,0,0,1,.266-.316,3.028,3.028,0,0,1,.406-.244h0l2.8-.5a2.478,2.478,0,0,1,.727-.063,1.806,1.806,0,0,1,.7.2,3.788,3.788,0,0,1,.61.452l.605.515.962.808h0a9.48,9.48,0,0,1,.863,1.079,1.405,1.405,0,0,1,.149.28.352.352,0,0,1,0,.262.519.519,0,0,1-.452.307h-.095v.09a4.784,4.784,0,0,1,.041.5.9.9,0,0,1-.068.452.145.145,0,0,1-.072.027.416.416,0,0,1-.113,0,2.05,2.05,0,0,1-.235,0,2.212,2.212,0,0,1-.244,0h-.063c.081-.063-.113.086-.095.068h0v.041a.455.455,0,0,1-.036.1.591.591,0,0,1-.28.294.509.509,0,0,1-.2.045.285.285,0,0,1-.185,0,1.129,1.129,0,0,1-.42-.668v-.063H572.9l-1.861.262h-.027a17.456,17.456,0,0,0-1.445,1.888c-.154.23-.267.416-.339.542A1.271,1.271,0,0,0,569.163,385.248Z",
    transform: "translate(-532.783 -313.85)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M578.8,327.38a1.352,1.352,0,0,1,0,.239c0,.181-.036.4-.059.673-.054.587-.145,1.432-.266,2.475-.244,2.087-.628,4.968-1.161,8.13s-1.152,6.007-1.662,8.049c-.253,1.021-.452,1.843-.637,2.407-.081.262-.145.474-.194.65a1.021,1.021,0,0,1-.086.221.965.965,0,0,1,.041-.235c.041-.176.09-.393.149-.659.14-.605.334-1.427.565-2.421.452-2.05,1.052-4.891,1.59-8.048s.944-6.034,1.229-8.13c.14-1.012.257-1.847.343-2.462l.1-.673A.894.894,0,0,1,578.8,327.38Z",
    transform: "translate(-538.644 -286.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M534.213,369.648a.679.679,0,0,1,.036-.135l.136-.388.542-1.477c.483-1.3,1.174-3.134,2.014-5.375l.054.117L524.764,358.1l-5.75-2.037-.095-.032.023-.1,2.534-10.262.75-2.967c.09-.33.158-.592.212-.79a1.185,1.185,0,0,1,.086-.266,1.587,1.587,0,0,1-.05.275c-.041.2-.1.452-.172.8-.167.714-.4,1.725-.691,2.981l-2.452,10.284-.068-.135,5.736,2.028,12.195,4.336.09.032-.032.086-2.091,5.348-.587,1.463c-.063.154-.117.275-.158.379A.38.38,0,0,0,534.213,369.648Z",
    transform: "translate(-508.036 -294.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M522.774,396.513a5.719,5.719,0,0,1-.786-.131l-2.127-.452c-1.807-.379-4.273-.9-6.992-1.572s-5.158-1.382-6.9-1.965c-.867-.294-1.567-.542-2.046-.727a5.9,5.9,0,0,1-.736-.307,4.622,4.622,0,0,1,.768.221l2.069.655c1.748.542,4.182,1.229,6.9,1.892s5.185,1.219,6.969,1.639l2.114.506A4.566,4.566,0,0,1,522.774,396.513Z",
    transform: "translate(-499.41 -321.547)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M576.97,386.133h0a.732.732,0,0,0,.863.515l15-3.225,12.89-2.308.108-1.125-12.317,1.739-16,3.514a.718.718,0,0,0-.547.89Z",
    transform: "translate(-539.854 -315.312)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    d: "M620.414,342.235l-6.933,17.456a.967.967,0,0,0,1.07,1.3l15.311-2.778a.966.966,0,0,0,.75-.6l6.96-17.316a.519.519,0,0,0-.533-.7l-15.808,2.032A.976.976,0,0,0,620.414,342.235Z",
    transform: "translate(-559.852 -293.162)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M623.117,344.1c.059,0-1.6,4.367-3.713,9.706s-3.862,9.647-3.916,9.625,1.6-4.363,3.708-9.706S623.058,344.077,623.117,344.1Z",
    transform: "translate(-560.988 -295.632)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M640.487,360.956c-.452.845-.406,1.712.059,1.942s1.192-.262,1.626-1.107.406-1.707-.059-1.942S640.916,360.116,640.487,360.956Z",
    transform: "translate(-574.523 -304.237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-30",
    transform: "translate(732.965 1976.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M211.622,168.536a2.8,2.8,0,0,0-1.194-5.218,3.075,3.075,0,0,0-2.321-5.256,2.715,2.715,0,0,0,.584-2.922,4.112,4.112,0,0,0-2.194-2.173,5.785,5.785,0,0,0-7.327,2.668l1.372,24.057a4.129,4.129,0,0,0,6.776-1.745,8.2,8.2,0,0,0,2.512-.584,2.766,2.766,0,0,0,1.618-1.893,1.692,1.692,0,0,0-1.232-1.965,5.809,5.809,0,0,0,2.359-2.236A1.985,1.985,0,0,0,211.622,168.536Z",
    transform: "translate(-144.377 -151.51)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M206.906,156.415a5.357,5.357,0,0,0-2.232-2.965,3.269,3.269,0,0,0-1.423-.682,1.36,1.36,0,0,0-1.381.585l.089.885c-.093,1.41,1.012,2.575,1.55,3.884.233.568.424,1.271,1,1.487a1.321,1.321,0,0,0,.944-.025A2.734,2.734,0,0,0,206.906,156.415Z",
    transform: "translate(-145.933 -151.634)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M185.755,161.556a2.829,2.829,0,0,0-.356-3.613,1.905,1.905,0,0,0-.263-2.291,5.561,5.561,0,0,0-2.118-1.3A3.812,3.812,0,0,0,178.5,151.7c-1.029-1.419-3.138-1.584-4.8-1.046a4.481,4.481,0,0,1-1.245.313,8.78,8.78,0,0,1-.936-.1,4.073,4.073,0,0,0-4,2.689,3.08,3.08,0,0,1-.339.75,4.4,4.4,0,0,1-.826.7,2.711,2.711,0,0,0-.987,2.05,4.994,4.994,0,0,1-.038,1.978c-.131.309-.377.559-.479.877-.288.923.75,1.83.593,2.783-.034.195-.114.377-.165.568a1.694,1.694,0,0,0,.14,1.177,2.338,2.338,0,0,1,.394.847,2.834,2.834,0,0,1-.114.695,6.082,6.082,0,0,0,1.694,3.007l14.62-.3a2.736,2.736,0,0,0,2.046-2.418.961.961,0,0,1,.119-.538,1.1,1.1,0,0,1,.39-.271c.928-.534,1-1.83.872-2.893a1.309,1.309,0,0,1,0-.445,1.631,1.631,0,0,1,.326-.568Z",
    transform: "translate(-124.558 -150.265)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M5.22,25.635v-3.88S1.45,21.287.48,16.431A52.179,52.179,0,0,1,.027,6.769,8.045,8.045,0,0,1,3.767.836,5.932,5.932,0,0,1,7.194.013,9.659,9.659,0,0,1,10.955.8a7.831,7.831,0,0,1,4.354,6.7l-.1,3.476a.439.439,0,0,1,.207-.124c.951-.188,2.685-.182,2.8,2.255a2.5,2.5,0,0,1-3.146,2.74l-.29,10.4L4.9,28.692Z",
    transform: "translate(41.725 3.931)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M172.59,184.588a.627.627,0,0,0,.631.61.606.606,0,0,0,.623-.593.627.627,0,0,0-.631-.606.593.593,0,0,0-.623.589Z",
    transform: "translate(-129.054 -169.65)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    d: "M171.146,178.765c.08.08.542-.288,1.216-.313s1.182.288,1.249.2-.051-.182-.271-.33a1.715,1.715,0,0,0-1-.267,1.694,1.694,0,0,0-.966.356C171.171,178.583,171.108,178.731,171.146,178.765Z",
    transform: "translate(-128.215 -166.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M178.673,184.268a4.512,4.512,0,0,0-1.1-.152c-.174,0-.339-.038-.373-.157a.9.9,0,0,1,.093-.517c.148-.424.3-.847.457-1.33a22.641,22.641,0,0,0,1-3.473,22.4,22.4,0,0,0-1.271,3.388l-.424,1.338a.987.987,0,0,0-.064.678.423.423,0,0,0,.3.241,1.067,1.067,0,0,0,.292.03A4.468,4.468,0,0,0,178.673,184.268Z",
    transform: "translate(-131.575 -166.561)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M180.611,208.072a12.46,12.46,0,0,0,6.472-2.012s-1.584,3.579-6.493,3.32Z",
    transform: "translate(-133.666 -182.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    d: "M171.539,172.868c.119.161.631.03,1.237.055s1.114.165,1.237,0c.059-.076,0-.233-.229-.39a1.931,1.931,0,0,0-1.995-.055C171.565,172.64,171.489,172.792,171.539,172.868Z",
    transform: "translate(-128.44 -162.865)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    d: "M187.229,184.56a.623.623,0,0,1-.6.631.593.593,0,0,1-.648-.563.623.623,0,0,1,.6-.631.6.6,0,0,1,.648.563Z",
    transform: "translate(-136.773 -169.648)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    "data-name": "Path 3270",
    d: "M189.61,178.586c-.076.08-.551-.267-1.228-.267s-1.169.343-1.241.263.042-.186.258-.343a1.724,1.724,0,0,1,1-.309,1.639,1.639,0,0,1,.974.313C189.563,178.383,189.631,178.548,189.61,178.586Z",
    transform: "translate(-137.43 -166.152)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    "data-name": "Path 3271",
    d: "M189.719,173.184c-.131.157-.656,0-1.271,0s-1.156.106-1.271-.055c-.055-.076.03-.229.258-.377a1.965,1.965,0,0,1,1.042-.254,1.931,1.931,0,0,1,1.021.3C189.7,172.951,189.778,173.133,189.719,173.184Z",
    transform: "translate(-137.454 -163.02)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    "data-name": "Path 3273",
    d: "M205.728,190.164a1.535,1.535,0,0,0,.161.08.576.576,0,0,0,.424,0,1.434,1.434,0,0,0,.6-1.317,1.915,1.915,0,0,0-.2-.826.682.682,0,0,0-.457-.424.3.3,0,0,0-.335.178c-.042.093,0,.161-.034.165s-.076-.051-.055-.191a.381.381,0,0,1,.123-.216.423.423,0,0,1,.318-.1.8.8,0,0,1,.627.487,1.936,1.936,0,0,1,.246.919,1.532,1.532,0,0,1-.779,1.478.627.627,0,0,1-.534-.064C205.74,190.261,205.719,190.172,205.728,190.164Z",
    transform: "translate(-148.156 -171.677)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    d: "M166.59,164.007a1.936,1.936,0,0,0,.991-1.825c.449.114.881-.479,1.127-.872s.555-.606.517-1.072a.534.534,0,0,1,.021-.271c.064-.131.22-.178.356-.224a2.236,2.236,0,0,0,1.41-1.609,4.71,4.71,0,0,0,2.3.284,1.808,1.808,0,0,0,3.049-.254,1.6,1.6,0,0,0,1.114.754,4.74,4.74,0,0,0,1.385.021,1.906,1.906,0,0,0,1.343,2.118c.119.034.258.064.318.174a.487.487,0,0,1-.038.373,1.5,1.5,0,0,0,1.084,1.872,1.122,1.122,0,0,0,.169,1.753c.123.068.288.148.271.292a.334.334,0,0,1-.064.144,2.152,2.152,0,0,0-.483,1.122.8.8,0,0,0,.695.847,1.063,1.063,0,0,0-.394.745c0,.288.309.572.576.457a18.742,18.742,0,0,0,1.83-.542c.889-1.317-.352-2.685-.508-4.265a10.347,10.347,0,0,0-1.618-4.443,7.623,7.623,0,0,0-1.245-1.559,10.376,10.376,0,0,0-1.885-1.271,9.216,9.216,0,0,0-2.723-1.169,8.459,8.459,0,0,0-5.3,1.216,7.873,7.873,0,0,0-1.766,1.139A7.09,7.09,0,0,0,167.67,160a8.729,8.729,0,0,0-1.072,3.456",
    transform: "translate(-125.595 -153.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    d: "M164.94,159.768a1.4,1.4,0,0,1,.165-.364c.068-.11.161-.246.25-.424a1.516,1.516,0,0,0,.161-.627,4.76,4.76,0,0,0-.047-.847,3.635,3.635,0,0,1,0-.987,2.812,2.812,0,0,1,.4-1.067,2.68,2.68,0,0,1,.394-.487,3.712,3.712,0,0,1,.508-.424,2.118,2.118,0,0,0,.491-.457,2.758,2.758,0,0,0,.292-.639,4.235,4.235,0,0,1,.758-1.317,4.329,4.329,0,0,1,1.271-1.046,4.064,4.064,0,0,1,.788-.33,3.533,3.533,0,0,1,.872-.131,3.977,3.977,0,0,1,.449,0,3.183,3.183,0,0,1,.449.064,2.173,2.173,0,0,0,.889-.034c.3-.072.584-.191.889-.275a5.338,5.338,0,0,1,.936-.2,5.784,5.784,0,0,1,.978-.047,4.9,4.9,0,0,1,.983.14,3.282,3.282,0,0,1,1.72,1.042l.127.161-.051-.021a3.867,3.867,0,0,1,4.566,2.749l-.025-.034a11.864,11.864,0,0,1,1.19.572,3.621,3.621,0,0,1,.987.817,2.266,2.266,0,0,1,.474,1.135,1.563,1.563,0,0,1-.275,1.139v-.059a2.774,2.774,0,0,1,.847,1.694,2.846,2.846,0,0,1-.284,1.669,3.81,3.81,0,0,1-.208.339c-.08.106-.157.2-.22.3a.741.741,0,0,0-.106.33,1.889,1.889,0,0,0,0,.347,5.306,5.306,0,0,1,0,1.271,2.613,2.613,0,0,1-.288.974,1.6,1.6,0,0,1-.5.559c-.165.123-.318.169-.4.237a.705.705,0,0,0-.119.106.424.424,0,0,1,.11-.119c.08-.068.233-.123.394-.246a1.588,1.588,0,0,0,.479-.555,2.677,2.677,0,0,0,.275-.961,5.461,5.461,0,0,0-.021-1.271,1.954,1.954,0,0,1-.025-.356.779.779,0,0,1,.11-.36,3.207,3.207,0,0,1,.22-.313,2.871,2.871,0,0,0,.2-.33,2.749,2.749,0,0,0,.267-1.626,2.685,2.685,0,0,0-.813-1.631l-.03-.025.025-.03a1.5,1.5,0,0,0,.254-1.08,2.168,2.168,0,0,0-.462-1.084,3.388,3.388,0,0,0-.961-.8,10.856,10.856,0,0,0-1.182-.563h0a3.769,3.769,0,0,0-4.464-2.617h-.03l-.025-.025-.123-.152a3.176,3.176,0,0,0-1.669-1.012,5.317,5.317,0,0,0-.961-.14,5.585,5.585,0,0,0-.961.047,5.273,5.273,0,0,0-.923.2c-.3.085-.589.2-.894.275a2.167,2.167,0,0,1-.466.068,2.7,2.7,0,0,1-.457-.034l-.445-.064a3.308,3.308,0,0,0-1.271.106,4.013,4.013,0,0,0-.771.326,4.436,4.436,0,0,0-1.982,2.287,2.807,2.807,0,0,1-.3.656,2.119,2.119,0,0,1-.508.47,4.033,4.033,0,0,0-.5.424,2.542,2.542,0,0,0-.385.474,2.63,2.63,0,0,0-.394,1.042,3.57,3.57,0,0,0,0,.974,4.371,4.371,0,0,1,.038.847,1.579,1.579,0,0,1-.174.644c-.093.169-.191.3-.258.424a2.31,2.31,0,0,0-.144.258C164.965,159.739,164.965,159.773,164.94,159.768Z",
    transform: "translate(-124.644 -150.121)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M186.745,151.38s-.089-.047-.254-.119a2.278,2.278,0,0,0-.733-.186,2.117,2.117,0,0,0-1.088.2,2.185,2.185,0,0,0-.966.936,1.8,1.8,0,0,0-.148.385.424.424,0,0,0,.034.352l.089.11-.136-.034a1.364,1.364,0,0,0-1.029.161,1.291,1.291,0,0,0-.538.64,1.406,1.406,0,0,0-.11.551,1.914,1.914,0,0,1,0,.208v-.051a.874.874,0,0,1-.021-.152,1.321,1.321,0,0,1,.085-.58,1.347,1.347,0,0,1,.555-.686,1.461,1.461,0,0,1,1.093-.186l-.051.08a.512.512,0,0,1-.055-.424,1.8,1.8,0,0,1,.157-.424,2.228,2.228,0,0,1,1.012-.978,2.147,2.147,0,0,1,1.88.03,1.337,1.337,0,0,1,.182.11C186.728,151.363,186.749,151.375,186.745,151.38Z",
    transform: "translate(-134.387 -150.617)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M200.5,160.469a.811.811,0,0,1-.11.123,2.35,2.35,0,0,1-.368.275,1.537,1.537,0,0,1-.656.224,1.19,1.19,0,0,1-.847-.216h.072l-.093.14a1.69,1.69,0,0,1-.11.136,1.986,1.986,0,0,1-.813.551,2.059,2.059,0,0,1-.788.131,1.914,1.914,0,0,1-.529-.1.789.789,0,0,1-.178-.085,3.059,3.059,0,0,0,.707.114,2.2,2.2,0,0,0,.758-.144,2.084,2.084,0,0,0,.771-.529l.1-.131.089-.131.03-.047.042.034a1.105,1.105,0,0,0,.767.208,1.63,1.63,0,0,0,.631-.191C200.324,160.626,200.493,160.456,200.5,160.469Z",
    transform: "translate(-142.595 -156.086)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M204,167.3v.059a.517.517,0,0,1-.068.165.894.894,0,0,1-.525.377,1.694,1.694,0,0,1-.953-.068c-.174-.055-.352-.11-.534-.186a.936.936,0,0,1-.479-.424l-.021-.055.08.021a3.854,3.854,0,0,1-.966.631,1.694,1.694,0,0,1-.932.131,1.237,1.237,0,0,1-.589-.237.661.661,0,0,1-.123-.123c-.025-.03-.038-.047-.034-.047a2.135,2.135,0,0,0,.182.136,1.27,1.27,0,0,0,.572.2,1.72,1.72,0,0,0,.885-.148,3.846,3.846,0,0,0,.94-.623l.051-.042.025.064.021.047a.847.847,0,0,0,.424.356c.174.076.356.131.521.186a1.669,1.669,0,0,0,.911.089.881.881,0,0,0,.508-.33A1.512,1.512,0,0,0,204,167.3Z",
    transform: "translate(-144.197 -159.891)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    "data-name": "Path 3280",
    d: "M182.615,196.2a2.305,2.305,0,0,0,.584-.394,1.271,1.271,0,0,0,.208-1.533,1.08,1.08,0,0,0-.131-.2.546.546,0,0,0-.157-.144.169.169,0,0,0-.161,0,1.356,1.356,0,0,0-.182.1l-.678.424a3.013,3.013,0,0,1-.648.339,3.125,3.125,0,0,1,.58-.424c.186-.131.424-.28.656-.445a1.63,1.63,0,0,1,.216-.123.335.335,0,0,1,.3.025.67.67,0,0,1,.208.182,1.165,1.165,0,0,1,.152.224,1.44,1.44,0,0,1,.14,1,1.338,1.338,0,0,1-.424.707,1.242,1.242,0,0,1-.47.28A.92.92,0,0,1,182.615,196.2Z",
    transform: "translate(-134.162 -175.286)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    "data-name": "Path 3281",
    d: "M110.533,289.843l1.664-2.516,2.668-1.338.1-.072a3.57,3.57,0,0,1,3.028-.563c1.084.288,2.541.648,3.812.847l2.872-.788v5.608l-14.489-.915Z",
    transform: "translate(-93.082 -228.008)",
    fill: "#fff",
    stroke: "#263238",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    "data-name": "Path 3282",
    d: "M111.27,292.231a3.62,3.62,0,0,1,.61-.559c.394-.33.944-.771,1.559-1.271l.572-.445h0c.593-.11,1.11-.2,1.478-.258a2.347,2.347,0,0,1,.593-.059,2.342,2.342,0,0,1-.572.169c-.36.085-.872.2-1.465.318h.038l-.572.453c-.614.479-1.177.906-1.588,1.207A4.121,4.121,0,0,1,111.27,292.231Z",
    transform: "translate(-93.705 -230.548)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M113.94,294.725a16.467,16.467,0,0,1,2.084-1.271l.508-.28h0a11.06,11.06,0,0,1,1.855-.03,11.792,11.792,0,0,1-1.842.2h.038l-.508.28a16.116,16.116,0,0,1-2.135,1.1Z",
    transform: "translate(-95.244 -232.555)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M70.431,258.475a1.1,1.1,0,0,1,1.427.3L83.53,274.586l18.466.25c.737.042,1.631,1.533.97,2.257l-20.855-.267L70.075,260.1a1.1,1.1,0,0,1,.356-1.622Z",
    transform: "translate(-69.832 -212.501)",
    fill: "#8ad7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M70.4,258.453a.169.169,0,0,0-.093.051.992.992,0,0,0-.233.2,1.11,1.11,0,0,0-.186,1.156,5.879,5.879,0,0,0,.491.741l.614.847,1.529,2.143,9.474,13.223.025.038h.042l20.473.292h.424l.03-.034a1.008,1.008,0,0,0,.254-.741,1.851,1.851,0,0,0-.195-.741,2.25,2.25,0,0,0-.449-.61,1.063,1.063,0,0,0-.7-.326l-2.855-.038-5.506-.072-10.055-.127.068.034-9.169-12.35L71.8,258.686a1.118,1.118,0,0,0-1.038-.377.822.822,0,0,0-.364.144,1.272,1.272,0,0,1,.368-.114,1.093,1.093,0,0,1,1,.381L74.3,262.2l9.136,12.414.025.034H83.5l10.055.144,5.506.081,2.85.038a.872.872,0,0,1,.576.275,1.938,1.938,0,0,1,.4.555,1.135,1.135,0,0,1-.025,1.271l.072-.03h-.377l-20.473-.267.068.038-9.542-13.2-1.546-2.118-.623-.847a6.84,6.84,0,0,1-.5-.724,1.088,1.088,0,0,1,.144-1.118A1.271,1.271,0,0,1,70.4,258.453Z",
    transform: "translate(-69.797 -212.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M180.815,215.626a13.4,13.4,0,0,1,2.308,1.546,7.8,7.8,0,0,1,2.173,4.015c.39,1.91.076,9.017.076,11.13s-.538,10.055-.8,11.376a8.356,8.356,0,0,0,.784,4.561,2.648,2.648,0,0,1-.614,3.469l-22.663-.169.093-.847c.157-1.474-.394-2.965.169-4.345a14.77,14.77,0,0,0,.991-7.086s-2.829-3.511-.512-9.182c1.326-3.24,4.777-7.535,8.026-12.261,0,0,5.408-1.762,4.659-1.52A31.479,31.479,0,0,1,180.815,215.626Z",
    transform: "translate(-122.896 -187.873)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M140.38,245.6l19.36-4.045.5-16.806s.678-6.848,4.108-7.484l8.263,10.288c-.462,5.184-.042,14.989-2.423,18.775s-4.7,6.815-10.567,6.544-18.792-.394-18.792-.394Z",
    transform: "translate(-110.486 -188.83)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    d: "M186,274.78c-.047.038.424.644.809,1.487s.563,1.588.623,1.576a3.812,3.812,0,0,0-.424-1.66A3.723,3.723,0,0,0,186,274.78Z",
    transform: "translate(-136.78 -221.983)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2938",
    "data-name": "Group 2938",
    transform: "translate(44.688 35.204)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    d: "M180.511,233.24c-1.936,5.929-1.516,15.1-5.2,18.483l4.566-.957a23.354,23.354,0,0,1-.038-3.227c.373-4.7.424-9.474.673-14.3",
    transform: "translate(-175.31 -233.24)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M160.664,228.24a10.731,10.731,0,0,0-.339,1.347,15.787,15.787,0,0,0-.237,1.664c-.064.661-.072,1.423-.106,2.279-.11,3.431-.267,8.352-.457,14.353l.059-.076-19.36,4.049h-.085v.08c.14,2.2.292,4.519.445,6.882v.089h.089l2.355.03c3.367.042,6.649.093,9.822.161,1.588.034,3.143.072,4.659.123a24.042,24.042,0,0,0,4.489-.047,9.546,9.546,0,0,0,2.118-.542,8.9,8.9,0,0,0,1.855-1.012,12.677,12.677,0,0,0,2.8-2.905q.563-.792,1.067-1.588l.254-.394c.076-.136.148-.275.22-.423l.216-.424.169-.423a16.485,16.485,0,0,0,.847-3.359,53.573,53.573,0,0,0,.568-5.929c.085-1.749.123-3.257.169-4.489s.08-2.19.114-2.838c.021-.318.034-.563.047-.737a1.2,1.2,0,0,0,0-.25,1.59,1.59,0,0,1-.03.25c-.03.165-.034.424-.064.733-.047.648-.1,1.605-.152,2.838s-.106,2.74-.2,4.489a53.545,53.545,0,0,1-.593,5.908,16.323,16.323,0,0,1-.822,3.354c-.051.136-.106.275-.165.424a4.018,4.018,0,0,1-.212.4c-.072.136-.14.267-.22.4l-.25.39c-.335.529-.695,1.055-1.067,1.58a12.579,12.579,0,0,1-2.761,2.855,8.82,8.82,0,0,1-1.825.991,9.611,9.611,0,0,1-2.067.529,24.722,24.722,0,0,1-4.451.038c-1.525-.042-3.083-.093-4.659-.127-3.172-.072-6.459-.127-9.822-.169l-2.355-.025.1.093q-.235-3.545-.449-6.882l-.076.1,19.355-4.057h.059v-.064c.165-6,.3-10.923.39-14.353.025-.847.03-1.618.085-2.279s.136-1.211.216-1.66.157-.784.212-1.012c.025-.11.047-.191.064-.254A.175.175,0,0,0,160.664,228.24Z",
    transform: "translate(-110.348 -195.154)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M98.5,372.1l2.774,21.177-7.255,1.232L88.86,375.721Z",
    transform: "translate(-80.786 -278.085)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M115.47,303.171s-26.526-1.8-32.032-.9c-3.329.551-6.2,5.929-4.384,9.178a49.1,49.1,0,0,1,2.211,6.306l14.256-3.367Z",
    transform: "translate(-74.81 -237.685)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M107.338,339.18l5.743,9.08-6.76,4.536L98.99,341.154Z",
    transform: "translate(-86.626 -259.108)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M132.337,300.607s2.677,12.68-1.724,17.835-10.9,5.15-17.593,4.159-22.583-1.334-22.583-1.334.712,4.5,1.228,9.623.627,8.365.627,8.365l-9.949.847s-5.54-17.479-6.4-20.939-.563-8.111,2.384-9.839c2.5-1.461,22.2-7.12,31.633-7.962l1.025-.911Z",
    transform: "translate(-73.101 -236.781)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M99.24,339.637c0,.034.385.093.978.309a6.7,6.7,0,0,1,.991.479,7.28,7.28,0,0,1,1.084.817,7.048,7.048,0,0,1,.9,1.033,6.535,6.535,0,0,1,.559.978,7.274,7.274,0,0,0,.424.97.9.9,0,0,0-.042-.284,4.332,4.332,0,0,0-.237-.745,5.381,5.381,0,0,0-.542-1.021,6.356,6.356,0,0,0-.911-1.076,6.426,6.426,0,0,0-1.122-.847,5.608,5.608,0,0,0-1.038-.453,4.113,4.113,0,0,0-.741-.165.792.792,0,0,0-.3,0Z",
    transform: "translate(-86.77 -259.362)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M100.271,312.065A2.9,2.9,0,0,0,99.75,311a2.965,2.965,0,0,0-.75-.9,4.752,4.752,0,0,0,.61,1.008,5.015,5.015,0,0,0,.661.957Z",
    transform: "translate(-86.632 -242.344)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M75.53,315.542a.263.263,0,0,0,.03-.1c.021-.08.042-.174.068-.3.059-.254.152-.635.3-1.114a8.708,8.708,0,0,1,.707-1.664,4.091,4.091,0,0,1,1.605-1.673,42.787,42.787,0,0,1,5.73-2.118c2.2-.682,4.625-1.406,7.2-2.118,5.125-1.406,9.826-2.418,13.248-3.007,1.694-.3,3.1-.5,4.066-.64l1.11-.157.288-.047.1-.021h-.1l-.288.025-1.114.123c-.966.114-2.359.3-4.079.58a130.786,130.786,0,0,0-13.273,2.965c-2.567.7-4.993,1.427-7.2,2.118a40.762,40.762,0,0,0-5.739,2.16,4.159,4.159,0,0,0-1.639,1.741A8.627,8.627,0,0,0,75.86,314c-.136.483-.216.868-.263,1.127-.021.123-.038.22-.051.3Z",
    transform: "translate(-73.102 -238.015)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    d: "M91.257,417.6l-.241-.919a13.553,13.553,0,0,0,8.009-3.579l2.461,5.506-16.4,7.581C84.467,424.54,91.257,417.6,91.257,417.6Z",
    transform: "translate(-78.588 -301.72)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M101.41,424.277l-.6-1.347-15.531,7.763s-.584.656-.267,1.139Z",
    transform: "translate(-78.513 -307.387)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M100.225,423.037c.038.076.457-.072.97,0s.872.322.932.254-.271-.479-.889-.559S100.174,422.97,100.225,423.037Z",
    transform: "translate(-87.335 -307.266)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M115.236,421.141a.47.47,0,0,0,.631.225.479.479,0,0,0,.22-.635.47.47,0,0,0-.631-.224A.479.479,0,0,0,115.236,421.141Z",
    transform: "translate(-95.965 -305.962)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M97.344,420.832a1.042,1.042,0,0,0,.373-.072,1.965,1.965,0,0,0,.919-.508,1.378,1.378,0,0,0,.216-.292.906.906,0,0,0,.14-.39.424.424,0,0,0-.258-.423.593.593,0,0,0-.5,0,1.9,1.9,0,0,0-1.016,1.66l.241-.038a1.975,1.975,0,0,0-.161-.381,2.008,2.008,0,0,0-1.779-1.042.691.691,0,0,0-.275.055.377.377,0,0,0-.186.254.7.7,0,0,0,.119.491,1.52,1.52,0,0,0,.631.521,2.449,2.449,0,0,0,1.122.174,1.443,1.443,0,0,0,.424-.034,1.181,1.181,0,0,0-.424-.064,2.7,2.7,0,0,1-1.05-.237,1.3,1.3,0,0,1-.534-.474.457.457,0,0,1-.076-.33c0-.093.1-.127.25-.123a1.8,1.8,0,0,1,1.559.932,2.278,2.278,0,0,1,.144.335.119.119,0,0,0,.152.08.14.14,0,0,0,.089-.119,1.694,1.694,0,0,1,.847-1.457c.22-.123.479,0,.462.186a1.169,1.169,0,0,1-.28.576,2.076,2.076,0,0,1-.847.534A1.432,1.432,0,0,0,97.344,420.832Z",
    transform: "translate(-84.358 -305.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M97.26,426a5.607,5.607,0,0,1,1.084.08,6.349,6.349,0,0,1,1,.453,1.393,1.393,0,0,0-.949-.64A1.351,1.351,0,0,0,97.26,426Z",
    transform: "translate(-85.629 -309.051)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M95.1,428.674c0,.055.449.042.961.2s.881.424.915.368a1.453,1.453,0,0,0-.847-.559,1.389,1.389,0,0,0-1.029-.013Z",
    transform: "translate(-84.383 -310.645)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M106.751,361.069l-.385-.847a13.765,13.765,0,0,0,7.314-4.921l3.316,5-14.934,10.292C101.186,369.1,106.751,361.069,106.751,361.069Z",
    transform: "translate(-88.343 -268.4)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M116.91,365.4l-.809-1.22-14.049,10.36s-.47.75-.076,1.169Z",
    transform: "translate(-88.257 -273.519)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M113.722,367.943c.051.072.424-.148.957-.157s.915.161.961.085-.343-.424-.97-.394S113.662,367.888,113.722,367.943Z",
    transform: "translate(-95.115 -275.419)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M128.242,363.551a.466.466,0,0,0,.656.11.479.479,0,0,0,.119-.665.466.466,0,0,0-.661-.11.479.479,0,0,0-.114.665Z",
    transform: "translate(-103.439 -272.721)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M110.6,365.659a1.143,1.143,0,0,0,.356-.135,2.007,2.007,0,0,0,.822-.661,1.39,1.39,0,0,0,.165-.326.949.949,0,0,0,.072-.424.424.424,0,0,0-.322-.368.623.623,0,0,0-.487.11,1.935,1.935,0,0,0-.728,1.813l.233-.08a2.171,2.171,0,0,0-.22-.347,1.986,1.986,0,0,0-1.923-.716.661.661,0,0,0-.263.1.373.373,0,0,0-.144.284.669.669,0,0,0,.2.462,1.452,1.452,0,0,0,.7.423,2.541,2.541,0,0,0,1.139-.025,1.494,1.494,0,0,0,.4-.106,1.219,1.219,0,0,0-.424,0,2.648,2.648,0,0,1-1.072-.051,1.317,1.317,0,0,1-.6-.373.457.457,0,0,1-.131-.313c0-.1.076-.144.224-.165a1.779,1.779,0,0,1,1.694.644,2.173,2.173,0,0,1,.195.3.123.123,0,0,0,.165.055.14.14,0,0,0,.068-.131,1.715,1.715,0,0,1,.61-1.584c.2-.161.47-.1.483.1a1.169,1.169,0,0,1-.178.618,2.118,2.118,0,0,1-.728.673C110.705,365.57,110.591,365.642,110.6,365.659Z",
    transform: "translate(-91.912 -273.262)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M111.26,371.4a6.122,6.122,0,0,1,1.08-.11,5.858,5.858,0,0,1,1.055.275,1.39,1.39,0,0,0-1.042-.47A1.351,1.351,0,0,0,111.26,371.4Z",
    transform: "translate(-93.699 -277.496)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M109.54,374.468c0,.055.449-.034.983.034s.932.258.957.208a1.381,1.381,0,0,0-.936-.4A1.4,1.4,0,0,0,109.54,374.468Z",
    transform: "translate(-92.708 -279.339)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolCard);
export default __webpack_public_path__ + "static/media/school_card.bb176900646179115e6a62d1c75cdc01.svg";
export { ForwardRef as ReactComponent };